module.exports = __webpack_public_path__ + "static/media/card-options-area-bg.086b6bc5.png";